import MobileContainer from "./Container.mobile";

export default MobileContainer;
